import React from 'react';
import { Box, Link } from '@material-ui/core';
import { Doc } from 'src/types';

const FileAttachmentRenderer = ({
  value: documents = []
}: { value: Doc[] }) => (
  <Box display="flex" flexDirection="vertical">
    {
      documents.map((document) => (
        <Link href={document.url} color="inherit">
          {document.fileName}
        </Link>
      ))
    }
  </Box>
);
export default FileAttachmentRenderer;
